import { take, call, put} from 'redux-saga/effects';
import {
	uploadDecodeTarget,
	successUploadDecodeTarget,
	failUploadDecodeTarget,
	uploadManualDecode,
	failUploadManualDecode,
	successUploadManualDecode
} from '../actions';
import superFetchObject from '../modules/superFetchObject';
import {getApiUrl} from "./index";
import superFetch from "../modules/superFetch";

export function* handleUploadDecodeTarget() {
	while (true) {

		const action = yield take(`${uploadDecodeTarget}`);
		const formData = new FormData();
		action.payload.files.forEach((file,index)=>{
			formData.append('file'+index,file);
		});
		formData.append('SessionID',action.payload.SessionID);

		const {payload,err} = yield call(superFetchObject, {
			url: getApiUrl() + 'decoder/',
			data: formData
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUploadDecodeTarget({err:msg}));
			continue;
		}
		yield put(successUploadDecodeTarget(Object.assign({}, payload.data, {})));
	}
}

export function* handleUploadManualDecodes() {
	while (true) {
		const action = yield take(`${uploadManualDecode}`);
		const { payload, err } = yield call(superFetch, {
			url: getApiUrl() + 'manual-decode/',
			type: 'POST',
			data: action.payload
		});
		if (err || payload.state === 'NG') {
			const msg = (err) ? String(err).split('Error: ')[1] : payload.message;
			yield put(failUploadManualDecode({err:msg}));
			continue;
		}
		yield put(successUploadManualDecode(Object.assign({}, payload, {})));
	}
}


// WEBPACK FOOTER //
// ./src/sagas/upload-receipt.js